import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./page.css"
import { partialBoxColumn, partialColumn } from "../metadata/partial";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from 'primereact/toast';
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSendPartialMutation } from "../store/api/partialApi";
import { useCreateOrUpdateBoxMutation, useGetBoxQuery, useGetBoxesByPartialQuery } from "../store/api/boxApi";
import { useDispatch } from "react-redux";
import { addBox } from "../store/slices/box";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { Column } from "primereact/column";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { useGetManifestDataQuery } from "../store/api/orderAPI";
import ExcelExport from "../components/common/ExcelExport";
import { t } from "i18next";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";




function PartialDetail() {
	const { id } = useParams();
	const { data = [], error, isLoading } = useGetBoxesByPartialQuery(id);
	const [sendPartial] = useSendPartialMutation()
	const [userInteracted, setUserInteracted] = useState(false);
	const audioSuccess = useRef(new Audio("/scun.mp3"));
	const audioError = useRef(new Audio("/error.mp3"));

	const location = useLocation();
	const toast = useRef(null);
	const refEl = useRef(null);
	const [formData, setFormData] = useState({

	});
	const { data: menifestData } = useGetManifestDataQuery({ partial: id });
	const partialBoxColumnTr = useTranslatedColumns(partialBoxColumn);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { data: box = [], isLoading: isLoadingBox } = useGetBoxQuery(
		{ boxId: formData?.boxId },
		{
			skip: !formData?.boxId, // 👈 не делать запрос, пока boxId не задан
		}
	);
	const [createOrUpdateBox] = useCreateOrUpdateBoxMutation();
	const actions = useActionsHook([
		{
			onClick: (...params) => {
				console.log(params);
				navigate("/scannerPanel/" + params[1]?.tracking_code);
				dispatch(addBox(params[1]));
			},
			icon: "pi pi-eye"
		},
		{
			onClick: (...params) => {
				console.log(params);

			},
			icon: "pi pi-trash"
		}
	])
	const items = [

		{
			label: 'React Website',
			icon: 'pi pi-external-link',
			command: () => {

			}
		}
	];

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		console.log(data);
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}

	const lastYearTotal = () => {
		let width = 0;
		let height = 0;
		let length = 0;
		let v_weight = 0
		let gross_weight = 0

		for (let sale of data) {
			width += sale.width;
			height += sale.height;
			length += sale.length;
			v_weight += (sale.width * sale.height * sale.length) / 6000;
			gross_weight += sale.gross_weight;
		}

		return {
			"width": width,
			"height": height,
			"length": length,
			"v_weight": v_weight.toFixed(2),
			"gross_weight": gross_weight,
		};
	};

	const confirm1 = () => {
		confirmDialog({
			message: t("confirmActions"),
			header: t("makeShipment"),
			icon: 'pi pi-exclamation-triangle',
			defaultFocus: 'accept',
			acceptLabel: t("accept"),
			rejectLabel: t("reject"),
			accept: () => {
				sendPartial({
					partial: id
				})
			}
		});
	};

	const handleScan = async (e) => {
		if (box[0]) {
			try {
				const result = await createOrUpdateBox({
					...box[0],
					partial: id
				})
				if (userInteracted) audioSuccess.current?.play();
				toast.current.show({
					severity: "Success",
					summary: "Success",
					detail: t("boxAdded"),
					life: 10000,
				});
			} catch (e) {
				if (userInteracted) audioError.current?.play();
				toast.current.show({
					severity: "error",
					summary: "Не удалось добавить",
					detail: "Не удалось добавить короб",
					life: 10000,
				});
			}

		} else {
			if (userInteracted) audioError.current?.play();
			toast.current.show({
				severity: "error",
				summary: "Нет короба с таким номером",
				detail: "Нет короба с таким номером",
				life: 10000,
			});
		}
	};

	useEffect(() => {
		if (refEl.current) {
			refEl.current.focus();
		}
	}, [])

	useEffect(() => {
		const handleInteraction = () => {
			setUserInteracted(true);
			window.removeEventListener("keydown", handleInteraction);
			window.removeEventListener("click", handleInteraction);
		};
		window.addEventListener("keydown", handleInteraction);
		window.addEventListener("click", handleInteraction);
	}, []);

	const footerGroup = (
		<ColumnGroup>
			<Row>
				<Column footer={t("results")} colSpan={5} footerStyle={{ textAlign: 'right' }} />
				<Column />
				<Column />
				<Column />
				<Column footer={lastYearTotal().v_weight} />
				<Column footer={(lastYearTotal().gross_weight).toFixed(2)} />
			</Row>
		</ColumnGroup>
	);
	return (<>
		<Toast ref={toast} />
		<div className="topBar">
			<p
				style={{
					paddingLeft: 12,
					fontSize: 18,
					fontWeight: 600,
				}}
			>
				{t("partial")}
			</p>
			{
				location.state?.typePartial != 16 &&
				<MyButton label={t("makeShipment")} outlined size="small" onClick={confirm1} />
			}
		</div>
		<div
			style={{
				display: "flex",
				alignItems: "center",
				gap: 12,
				width: "100%",
				paddingLeft: 12
			}}
		>
			<Editor onBlur={onBlur} attr="boxId" refEl={refEl} />
			<MyButton
				label={t("addBox")}
				icon="pi pi-barcode"
				outlined
				onClick={handleScan}
				disabled={(!box[0]?.guid && !id)}
			/>
			{/* <MyButton label="Загрузить манифест" onClick={() => {
				console.log(menifestData);
			}} /> */}
			<ExcelExport data={menifestData} />
		</div>
		<p style={{
			paddingLeft: 12,
			fontWeight: 700,
			letterSpacing: 2,
			textDecoration: "underline"
		}}>{
				box[0]?.tracking_code
			}</p>
		<PresortDemo
			isLoading={isLoading}
			data={data}
			column={partialBoxColumnTr}
			toggleSidebar={toggleSidebar}
			deleteHandler={(row, field) => {
				console.log(row, field);
			}}
			footerColumnGroup={footerGroup}
			actions={actions}
		/>
		<SpeedDial
			model={items}
			radius={120}
			type="quarter-circle"
			onClick={() => {
				toggleSidebar(true, {});
			}}
			direction="up-left"
			style={{ right: 15, bottom: 15 }} />
		<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
			<div className="user-sidebar">
				<div className="user-sidebar-edit">
					{
						partialColumn.filter((i) => i.editor).map(el => {
							return (
								<div>
									<Editor {...el} onBlur={onBlur} data={formData} />
								</div>
							)
						})
					}
					<div></div>
					<MyButton label={t("save")} onClick={async () => {
						// await createOrUpdatePartial(formData);
						toast.current.show({ severity: 'info', summary: 'Success', detail: t("successSaved"), life: 3000 });
						toggleSidebar(false)
					}} />
				</div>
			</div>
		</Sidebar>
	</>);
}

export default PartialDetail;